<template>
  <header class="header">
    <!-- Старые пункты меню (не используются):
    <a href="#" v-scroll-to="'#new'">Новинки</a>
    <a href="#" v-scroll-to="'#series'">Pulpy-сериал</a>
    -->

    <a
      v-for="item in navLinks"
      :key="item.attributes.id"
      :href="item.attributes.link"
    >
      {{ item.attributes.title }}
    </a>
    <a
      href="#"
      class="link-button"
      @click.prevent="$modal.show('buy-online')"
    >
      Купить онлайн
    </a>
  </header>
</template>

<script>
import { sortNavMenuItems } from '@/utils/menuNav';

export default {
    name: "PageHeader",
    computed: {
      navLinks() {
        return sortNavMenuItems(this.$store.getters.menuList);
      },
    },
    mounted() {
      console.log(process.env.VUE_APP_URL);
      this.$store.dispatch('getMenuList');
    }
  }
</script>

<style scoped lang="scss">
  @import "header";
</style>
